<div>
  @if (config.header) {
    <p class="mat-headline-large" mat-dialog-title>{{ config.header }}</p>
  }
  <mat-dialog-content>
    <app-media-lockable class="lock" [config]="config.lock" (unlocked)="mediaLockUnlocked()" (error)="mediaLockError()" />
  </mat-dialog-content>
  <mat-dialog-actions [style]="config.footerStyle">
    @if (showButton()) {
      <app-button class="ui-button" [config]="config.negativeButton" (buttonClick)="onNegativeClick()" />
    }
  </mat-dialog-actions>
</div>
